import Vue from 'vue';
import { Component, Prop, Watch, PropSync } from 'vue-property-decorator'
import PopupModal from '@/components/common/Modal/PopupModal.vue'
//YSJ
//import { mapGetters, mapMutations } from 'vuex'
import { mapActions, mapGetters, mapMutations } from 'vuex';

import * as types from '@workflow/store/types'
import * as accountTypes from '@account/store/types'
import api from '@workflow/api'
@Component({
    name: 'ApprovalProcessingModal',
    components: { PopupModal },
    computed: {
        ...mapGetters({
            User: accountTypes.USER,
            current: types.WORKFLOW_CURRENT,
        }),
    },
    methods: {
        ...mapActions({
            setCurrent : types.WORKFLOW_CURRENT
        }),
        ...mapMutations({

        })
    }
})
export default class ApprovalProcessingModal extends Vue {
    //
    // ────────────────────────────────────────────────── I ──────────
    //   :::::: P R O P S : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────
    //

    @Prop({ type: Boolean }) show!: boolean
    @Prop({ type: Object }) actionItem!: workflow.TC_APM_MENUS
    //
    // ────────────────────────────────────────────────────── I ──────────
    //   :::::: G E T T E R S : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────────
    //

    User!: account.User
    current!: workflow.CM_Form

    //
    // ────────────────────────────────────────────────────────── I ──────────
    //   :::::: A C T I O N S : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────────────
    //

    setCurrent!: (data: any) => Promise<any>;

    //
    // ──────────────────────────────────────────────── I ──────────
    //   :::::: D A T A : :  :   :    :     :        :          :
    // ──────────────────────────────────────────────────────────
    //
    actionFlag: boolean = false;
    comment: string = ''
    item: any = {} as workflow.WorkflowItem
    //
    // ────────────────────────────────────────────────── I ──────────
    //   :::::: W A T C H : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────
    //

    @Watch('current')
    onChangedWorkflowDetail() {
        if (this.current) {
            this.item = this.current
        }
    }

    async action(item: workflow.TC_APM_MENUS) {
        if (item.actionId) {

            // ISU Custom Valid
            if (item.menuName == 'ISU_접수취소') {
                if (!await(window as any).confirmAsync(this.$t('접수취소를_하시겠습니까').toString())) {
                    return;
                }
            }

            if (item.actionId == 'DD') {
                if (!await(window as any).confirmAsync(this.$t('정말_삭제하시겠습니까_삭제_시_복원할_수_없습니다').toString())) {
                    return;
                }
            }

            var rflag = false;
            if (!this.comment?.trim()) {
                item.nextActionList?.split(',').forEach((x) => {
                    if (['RJ','DL','GJ'].indexOf(x) != -1) {
                        rflag = true;
                    }
                });
            }

            if (rflag) {
                await(window as any).alertAsync(this.$t('의견을_입력해주세요').toString());
                return;
            }

            if (['RJ','DL','GJ'].includes(item.actionId) && !this.comment?.trim()) {
                await(window as any).alertAsync(this.$t('의견을_입력해주세요').toString());
                return;
            }

            if (!item.isCustom) {
                if (['ED'].includes(item.actionId) && !this.comment?.trim()) {
                    await(window as any).alertAsync(this.$t('의견을_입력해주세요').toString());
                    return;
                }
            }

            if (item.actionId == 'CO') {
                if (!await(window as any).confirmAsync(this.$t('처리완료하시겠습니까_').toString())) {
                    return;
                }
            }

            if (item.actionId == 'CH') {
                if (!await(window as any).confirmAsync(this.$t('확인완료하시겠습니까_').toString())) {
                    return;
                }
            }
            
        }
        if (this.actionFlag == false) {
            this.actionFlag = true;
            var data: any = {
                actionId: item.actionId,
                nextActionList: item.nextActionList,
                comment: this.comment,
                personCode: this.User.personCode,
                application: this.current.application,
                apm: this.current.apm,
                apmDetail: this.current.apmDetail,
                apmConnectList: this.current.apmConnectList,
                approvalLineList: this.current.approvalLineList,
                isMobile: true
            }
            api.form.actionForm(data).then(async res => {
                if (res.isError) {
                    await(window as any).alertAsync(res.message)
                } else {
                    if (res.isRedirect) {
                        var actionMessage = '';
                        let actionId = data.actionId.toUpperCase();

                        switch (actionId) {
                            case 'RT':
                                actionMessage = this.$t('문서를_회수했습니다').toString();
                                break;
                            case 'AP':
                                actionMessage = this.$t('문서를_상신했습니다').toString();
                                break;
                            case 'AV':
                                actionMessage = this.$t('문서를_승인했습니다').toString();
                                break;
                            case 'RJ':
                                actionMessage = this.$t('문서를_반송했습니다').toString();
                                break;
                            case 'DA':
                                actionMessage = this.$t('문서를_접수했습니다').toString();
                                break;
                            case 'DU':
                                actionMessage = this.$t('문서를_접수했습니다').toString();
                                break;
                            case 'TD':
                            case 'DD':
                                actionMessage = this.$t('문서를_삭제했습니다').toString();
                                break;
                            case 'RS':
                                actionMessage = this.$t('문서를_복원했습니다').toString();
                                break;
                        }

                        if (actionMessage) {
                            await(window as any).alertAsync(actionMessage);
                        }
                    }

                    this.reload()
                    this.$emit('goto')
                    this.actionFlag = false;
                    // this.$emit('close')
                }
            }).catch(async (err) => {
                console.log(err)
                await(window as any).alertAsync(err && err.responseText ? err.responseText : (err.message || 'Fail'));
                this.reload()
                this.$emit('goto')
                this.actionFlag = false;
            })
        }
    }

    reload() {
        var data: any = {
            apmId: Number(this.current.apm?.apmId), // 문서번호
            isMobile: true
        }

        this.setCurrent(data).then(res => {
        })
    }

    getActionChildItems() {
        return this.current.menus?.filter((x: any) => x.parentMenuId == this.actionItem?.menuId)
    }
}
